import React from "react";
import {
  Send,
  Activity,
  Users,
  Bell,
  IndianRupee,
} from "lucide-react";

const features = [
  {
    id: "submit",
    title: "Submit in under two minutes",
    description:
      "Borrower details, loan type, ticket size. From your phone, on the spot.",
    icon: <Send size={22} className="text-[var(--hero-green)]" strokeWidth={2.2} />,
  },
  {
    id: "real-time",
    title: "Real-time status",
    description:
      "See exactly where the file sits — verified, matched, reviewed, approved, disbursed.",
    icon: <Activity size={22} className="text-[var(--hero-green)]" strokeWidth={2.2} />,
  },
  {
    id: "support",
    title: "Training & Support",
    description:
      "Get continuous training and dedicated relationship manager support.",
    icon: <Users size={22} className="text-[var(--hero-green)]" strokeWidth={2.2} />,
  },
  {
    id: "notifications",
    title: "Notifications",
    description:
      "Alerts when a lender moves, asks for a document, or approves.",
    icon: <Bell size={22} className="text-[var(--hero-green)]" strokeWidth={2.2} />,
  },
  {
    id: "payout",
    title: "Commission dashboard",
    description:
      "Every payout tied to a lead ID and a disbursed amount.",
    icon: <IndianRupee size={22} className="text-[var(--hero-green)]" strokeWidth={2.2} />,
  },
];

function WhatYouGet() {
  return (
    <section className="relative overflow-hidden bg-white py-12 sm:py-16 lg:py-20">
      {/* Soft Ambient Radial Background Glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(46,229,162,0.06),transparent_50%)]"
      />

      <div className="section-container relative z-10">
        
        {/* ================= SECTION HEADER ================= */}
        <div className="mx-auto max-w-[720px] text-center">
          <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--hero-green)] sm:text-[12px] uppercase mb-2.5">
            WHAT YOU GET
          </p>
          <h2 className="font-bricolage text-[28px] sm:text-[34px] md:text-[40px] font-bold leading-[1.12] tracking-[-1px] text-[#111827]">
            What You Get with <span className="text-[var(--hero-green)]">Finverse</span>
          </h2>

          <p className="mt-2 font-jakarta text-[14px] sm:text-[15.5px] leading-[1.6] text-[#556369]">
            Empowering DSAs with the right tools, technology and support.
          </p>
        </div>

        {/* ================= 5 CARDS IN SNUG BALANCED RESPONSIVE GRID ================= */}
        <div className="mt-8 sm:mt-11 lg:mt-13 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3.5 sm:gap-4 lg:gap-4 xl:gap-5">
          {features.map((item) => (
            <div
              key={item.id}
              className="group relative flex h-full flex-col items-center justify-between rounded-[18px] sm:rounded-[22px] border border-[#e5ebe7] bg-white p-4 sm:p-5 lg:p-5.5 text-center shadow-[0_3px_15px_rgba(0,0,0,0.02)] transition-all duration-300 hover:-translate-y-1 hover:border-[var(--hero-green-border)] hover:shadow-[0_14px_30px_rgba(0,135,81,0.08)]"
            >
              <div className="w-full">
                {/* Round Icon Badge - Guaranteed 1:1 Aspect Ratio Circle */}
                <div className="mx-auto flex h-12 w-12 sm:h-13 sm:w-13 lg:h-14 lg:w-14 shrink-0 aspect-square items-center justify-center rounded-full bg-[var(--hero-green-light)] border border-[var(--hero-green-border)] text-[var(--hero-green)] shadow-2xs transition-transform duration-300 group-hover:scale-108">
                  {item.icon}
                </div>

                {/* Title */}
                <h3 className="mt-3 sm:mt-3.5 font-bricolage text-[16px] sm:text-[17px] font-bold leading-snug tracking-tight text-[#111827] group-hover:text-[var(--hero-green)] transition-colors duration-200">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="mt-1.5 font-jakarta text-[12.5px] sm:text-[13px] leading-[1.5] text-[#556369]">
                  {item.description}
                </p>
              </div>

              {/* Bottom Green Accent Indicator Dash */}
              <div className="mt-4 sm:mt-4.5 flex justify-center w-full">
                <div className="h-[2.5px] w-5 sm:w-6 rounded-full bg-[var(--hero-green)] transition-all duration-300 group-hover:w-9" />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default WhatYouGet;
